import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

class Button extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    loading:  PropTypes.bool
  }

  render() {
    const { className, loading, ...rest } = this.props;

    return (
      <button className={ classNames(className, 'form__button') }
        disabled={ this._isDisabled() }
        { ...rest }>
        { this._innerHTML(loading) }
      </button>
    );
  }

  // private

  _innerHTML(loading) {
    let inner = this.props.children;

    if (loading) {
      inner = <i className='fa fa-spin fa-circle-o-notch' />;
    }

    return inner;
  }

  _isDisabled() {
    const { disabled, loading } = this.props;

    return disabled || loading;
  }
}

export default Button;



// WEBPACK FOOTER //
// ./app/components/shared/form/_Button.jsx